import React from 'react';
import { Column, UseFiltersColumnOptions } from 'react-table';

import { Quality, QualityColumnType } from '../../../../Types/LotDetailQuality';
import NoFilter from '../../../../DataTable/datatable.nofilter';
import LBMLabCell from './LBMLabCell';

export interface LBMLabColumnProps {
    header: string,
    qualityType: string,
    qualityColumns: QualityColumnType[]
}
function LBMLabColumn({ header, qualityType, qualityColumns }: LBMLabColumnProps): Column<Quality> & UseFiltersColumnOptions<Quality> {
    return {
        Header: header,
        id: header,
        accessor: "qualityValues",
        Cell: (props) => <LBMLabCell quality={props.row.original} qualityType={qualityType} qualityColumns={qualityColumns} />,
        Filter: NoFilter
    }
}

export default LBMLabColumn;